/**
 * Labstep
 *
 * @module components/Folder/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete as DeleteAction } from 'labstep-web/components/Entity/Action/Delete';
import { Folder } from 'labstep-web/models/folder.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { FolderActionDeleteProps } from './types';

const folderHumanReadableEntityName =
  Folder.getHumanReadableEntityName(false, true);

export const FolderActionDelete: React.FC<
  FolderActionDeleteProps
> = ({ folder, ...rest }) => (
  <DeleteAction
    {...rest}
    entity={folder}
    confirmMessage={`Are you sure you want to delete this ${folderHumanReadableEntityName}? You may lose access to any ${getHumanReadableEntityName(
      folder.type,
      true,
      true,
    )} not in other ${Folder.getHumanReadableEntityName(true, true)}.`}
  />
);
